import React, { FC, PropsWithChildren } from "react"

export const SubscriptionGrid: FC<PropsWithChildren> = ({ children }) => {
  return <div className="grid mb-10 md:mb-12 gap-5 grid-cols-1 md:grid-cols-3 md:gap-6">{children}</div>
}
